// Укажите здесь дополнительные поля для расширенного конфига runtime.

export interface RuntimeConfigBase extends Record<string, string | undefined> {
  VITE_RUNTIME_SOGU_SERVICE_URL: string;
  VITE_RUNTIME_SENTRY_DSN: string;
  VITE_RUNTIME_SEARCH_API_URL: string;
  VITE_RUNTIME_AUDIOGUIDES_URL: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface RuntimeConfig extends RuntimeConfigBase {}

/**
 * Инициализирует расширенный конфиг runtime.
 *
 * Расширенный конфиг runtime используется для добавления дополнительных полей в конфиг runtime.
 * Применяется после инициализации основного конфига runtime.
 *
 * @returns расширенный конфиг runtime
 */
export const initRuntimeConfigExtends = (runtimeConfig: RuntimeConfigBase): RuntimeConfig => {
  return runtimeConfig;
};
